<template>
  <div>
    <SizeImp
    class="contentWrapper"
    :checkDate="checkDate"
    :clickDate="clickDate"
    :clearSelectedDate="clearSelectedDate"
    :viewData="viewData.data"
    ></SizeImp>
    <dateTable
    :checkDate="checkDate"
    :clickDate="clickDate"
    :campaginDaysData="viewData.daysData"
    :dataInfo="viewData.data"
    tab="size"
    ></dateTable>
  </div>
</template>

<script>
  import {mapState, mapMutations} from 'vuex'

  import SizeImp from '@/components/campaign/size/SizeImp'
  import dateTable from '@/components/campaign/campaignBotTable/dateTable'

  export default {
    name: 'sizeMain',
    components: {
      SizeImp,
      dateTable
    },
    data () {
      return {
        campaign: {},
        selectedDate: []
      }
    },
    methods: {
      ...mapMutations([
        'setCampaignDetailTap'
      ]),
      checkDate (date) { // 캠페인 상세 -> 상품,사이즈,소재/ 일별 에서 선택여부 확인(상세 데이터 표시/숨김에 사용)
        return this.selectedDate.indexOf(date) > -1
      },
      clickDate (date) { // 선택한 날짜가 이미 있으면 제거, 없으면 리스트에 추가
        if (this.checkDate(date)) {
          this.selectedDate.splice(this.selectedDate.indexOf(date), 1)
          return
        }
        this.selectedDate.push(date)
      },
      clearSelectedDate () { // 탭 변경시 선택했던 날짜 정보 초기화
        this.selectedDate = []
      }
    },
    computed: {
      ...mapState({
        sizeData: state => state.campaign.sizeData,
        currentCampaign: state => state.campaign.currentCampaign
      }),
      viewData () {
        return {
          data: this.sizeData.size,
          daysData: this.sizeData.sizeAndDate
        }
      }
    },
    created () {
      this.setCampaignDetailTap('size')
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// SizeMain.vue?39c6edde